// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-panel {
            position: absolute;
            right: 20px;
            top: 100px;
            width: 300px;
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            padding: 20px;
            z-index: 1000;
            display: block;
            cursor: grab;
            resize: both; /* Habilita el redimensionamiento */
            overflow: auto; /* Muestra barras de scroll si el contenido se desborda */
            min-width: 300px; /* Ancho mínimo */
            min-height: 400px; /* Alto mínimo */
            height: 30%;
        }
        .filter-panel.open {
            display: block;
        }


         .severity-selector {
            display: flex;
            gap: 8px;
            justify-content: space-between;
            width: 100%;
        }
        .severity-btn {
            flex: 1 1;
            padding: 6px 0;
            border: 1px solid #ccc;
            border-radius: 4px;
            background-color:var(--white-color);
            cursor: pointer;
            text-align: center;
            font-weight: bold;
            font-size: 13px;
            transition: background-color 0.2s, color 0.2s, border-color 0.2s;
            width: 30%;
            min-width: 40px;
            color: var(--third-color);
        }
        .severity-btn:hover {
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }
        .severity-btn.active {
            background-color: #007bff;
            color: #fff;
            border-color: #007bff;
        }

        .event-mix .group{
            width: 100% !important;

        }`, "",{"version":3,"sources":["webpack://./src/components/monitor-components/Events/styles/panelFiltros.css"],"names":[],"mappings":"AAAA;YACY,kBAAkB;YAClB,WAAW;YACX,UAAU;YACV,YAAY;YACZ,sBAAsB;YACtB,sBAAsB;YACtB,kBAAkB;YAClB,sCAAsC;YACtC,aAAa;YACb,aAAa;YACb,cAAc;YACd,YAAY;YACZ,YAAY,EAAE,mCAAmC;YACjD,cAAc,EAAE,yDAAyD;YACzE,gBAAgB,EAAE,iBAAiB;YACnC,iBAAiB,EAAE,gBAAgB;YACnC,WAAW;QACf;QACA;YACI,cAAc;QAClB;;;SAGC;YACG,aAAa;YACb,QAAQ;YACR,8BAA8B;YAC9B,WAAW;QACf;QACA;YACI,SAAa;YACb,cAAc;YACd,sBAAsB;YACtB,kBAAkB;YAClB,mCAAmC;YACnC,eAAe;YACf,kBAAkB;YAClB,iBAAiB;YACjB,eAAe;YACf,gEAAgE;YAChE,UAAU;YACV,eAAe;YACf,yBAAyB;QAC7B;QACA;YACI,qCAAqC;QACzC;QACA;YACI,yBAAyB;YACzB,WAAW;YACX,qBAAqB;QACzB;;QAEA;YACI,sBAAsB;;QAE1B","sourcesContent":[".filter-panel {\r\n            position: absolute;\r\n            right: 20px;\r\n            top: 100px;\r\n            width: 300px;\r\n            background-color: #fff;\r\n            border: 1px solid #ddd;\r\n            border-radius: 8px;\r\n            box-shadow: 0 4px 12px rgba(0,0,0,0.1);\r\n            padding: 20px;\r\n            z-index: 1000;\r\n            display: block;\r\n            cursor: grab;\r\n            resize: both; /* Habilita el redimensionamiento */\r\n            overflow: auto; /* Muestra barras de scroll si el contenido se desborda */\r\n            min-width: 300px; /* Ancho mínimo */\r\n            min-height: 400px; /* Alto mínimo */\r\n            height: 30%;\r\n        }\r\n        .filter-panel.open {\r\n            display: block;\r\n        }\r\n\r\n\r\n         .severity-selector {\r\n            display: flex;\r\n            gap: 8px;\r\n            justify-content: space-between;\r\n            width: 100%;\r\n        }\r\n        .severity-btn {\r\n            flex: 1 1 0px;\r\n            padding: 6px 0;\r\n            border: 1px solid #ccc;\r\n            border-radius: 4px;\r\n            background-color:var(--white-color);\r\n            cursor: pointer;\r\n            text-align: center;\r\n            font-weight: bold;\r\n            font-size: 13px;\r\n            transition: background-color 0.2s, color 0.2s, border-color 0.2s;\r\n            width: 30%;\r\n            min-width: 40px;\r\n            color: var(--third-color);\r\n        }\r\n        .severity-btn:hover {\r\n            box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n        }\r\n        .severity-btn.active {\r\n            background-color: #007bff;\r\n            color: #fff;\r\n            border-color: #007bff;\r\n        }\r\n\r\n        .event-mix .group{\r\n            width: 100% !important;\r\n\r\n        }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
